import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=f85a2e96&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=f85a2e96&scoped=true&lang=css&"
import style1 from "@/assets/css/common.css?vue&type=style&index=1&id=f85a2e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a2e96",
  null
  
)

export default component.exports